var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Menu } from 'antd';
import React from 'react';
import { WalletIcon } from './WalletIcon';
export const WalletMenuItem = (_a) => {
    var { onClick, wallet } = _a, props = __rest(_a, ["onClick", "wallet"]);
    return (React.createElement(Menu.Item, Object.assign({ className: "wallet-adapter-modal-menu-item" }, props),
        React.createElement(Button, { onClick: onClick, icon: React.createElement(WalletIcon, { wallet: wallet, className: "wallet-adapter-modal-menu-button-icon" }), type: "text", className: "wallet-adapter-modal-menu-button", htmlType: "button", block: true }, wallet.name)));
};
//# sourceMappingURL=WalletMenuItem.js.map